const MIXPANEL_REPEATED_PROPERTY_ORDER = [
  'event_timestamp',
  'user_id',
  'cefr_level',
  'book_id',
  'book_title',
  'level',
  'chunk',
  'stanza_number',
  'path',
  'email',
  'mode',
  'agent_type',
  'timestamp',
  'page',
];

export const orderMixpanelProperties = (properties = {}) => {
  const source = properties || {};
  const orderedProperties = {};

  MIXPANEL_REPEATED_PROPERTY_ORDER.forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(source, key)) {
      orderedProperties[key] = source[key];
    }
  });

  Object.entries(source).forEach(([key, value]) => {
    if (!Object.prototype.hasOwnProperty.call(orderedProperties, key)) {
      orderedProperties[key] = value;
    }
  });

  return orderedProperties;
};

export default orderMixpanelProperties;